import { PageHero, SectionShell } from "@/components/primitives";
import { EvidenceCard } from "@/sections/Experience";
import FinalCTA from "@/sections/FinalCTA";
import { useEvidence } from "@/lib/useEvidence";
import { Reveal } from "@/components/Reveal";
import { EDITORIAL_DISCLAIMER } from "@/data/content";

export default function Evidence() {
  const { records, loading } = useEvidence(false);
  return (
    <div data-testid="evidence-page">
      <PageHero
        label="Client Evidence"
        lines={["A documented record", "of visibility, delivered."]}
        intro="A broader portfolio of executive and organizational visibility engagements — spanning media, speaking platforms, industry recognition and strategic activations."
      />
      <SectionShell className="py-16 md:py-24">
        {loading ? (
          <p className="text-ink/50 font-body">Loading evidence…</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-l border-t hairline" data-testid="evidence-grid">
            {records.map((r, i) => <EvidenceCard key={r.slug} r={r} index={i} />)}
          </div>
        )}
        <Reveal delay={0.1}>
          <p className="mt-12 max-w-4xl text-xs leading-relaxed text-ink/45 font-body">{EDITORIAL_DISCLAIMER}</p>
        </Reveal>
      </SectionShell>
      <FinalCTA />
    </div>
  );
}
